<div class="row content-container">
  <div class="col-12 col-sm-12 main-content mynovi mynovi--history">
    <div class="button-bar button-bar--justify">
      <a [routerLink]="['/my/claims']">
        <strong>
          <svg class="icon-arrow-left" height="10" viewBox="0 0 6 10" width="6">
            <use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
          </svg>
          <span i18n="@@claims.detail.back.to.overview">
            Back to claim list
          </span>
        </strong>
      </a>
    </div>

    <h1 class="new-claim-overview-title" i18n="@@claims.order.overview.title">
      For which article would you like to create a claim
    </h1>

    <p class="new-claim-overview-intro">
      <span i18n="@@new.claim.overview.claim.contact">
        Claims can be submitted up to 24 hours after delivery. Please get in
        touch with your account manager if you have any questions or comments.
      </span>
    </p>

    <table class="new-claim-overview-table">
      <thead>
        <tr>
          <th colspan="2" i18n="@@claims.detail.table.header.order" scope="col">
            Order
          </th>
          <th i18n="@@new.claims.overview.article" scope="col">Article</th>
          <th i18n="@@new.claims.overview.amount" scope="col">Amount</th>
          <th i18n="@@order.potsize" scope="col">Pot size</th>
          <th i18n="@@order.height" scope="col">Pot height</th>
          <th i18n="@@new.claims.overview.price" scope="col">Price</th>
          <th i18n="@@new.claims.overview.claim" scope="col">Claim</th>
        </tr>
      </thead>
      <tbody>
        @for (shipmentLine of claimableShipmentLines; track shipmentLine) {
          <tr>
            <td class="new-claim-data_order">
              {{ shipmentLine.shipmentDate | customDate: "dd MMMM YYYY" }}
            </td>
            <td
              [description]="shipmentLine.description"
              [imageFormat]="80"
              [image]="getImageId(shipmentLine.image)"
              class="order-overview-table_image"
              render-product-image
            ></td>
            <td class="new-claim-data_description">
              {{ shipmentLine.description }}
            </td>
            <td class="order-overview-table_amount new-claim-data_amount">
              <span>
                {{ shipmentLine.boxQuantity }} (x{{
                shipmentLine.quantityPerBox
                }})
              </span>
            </td>
            <td class="order-overview-table_potsize new-claim-data_potsize">
              <div class="order-overview-table_icon-text">
                <svg
                  class="icon-potsize"
                  height="11"
                  viewBox="0 0 16 11"
                  width="16"
                  >
                  <use xlink:href="/images/icons/svg-sprite.svg#potsize"></use>
                </svg>
                <span>{{ shipmentLine.potSize || "-" }}</span>
              </div>
            </td>
            <td class="order-overview-table_height new-claim-data_potheight">
              <div class="order-overview-table_icon-text">
                <svg
                  class="icon-potheight"
                  height="11"
                  viewBox="0 0 6 11"
                  width="6"
                  >
                  <use xlink:href="/images/icons/svg-sprite.svg#potheight"></use>
                </svg>
                <span>{{ shipmentLine.potHeight || "-" }}</span>
              </div>
            </td>
            <td class="order-overview-table_price new-claim-data_price">
              {{ applicationService.getUserCurrency() }}
              {{ shipmentLine.previousPrice | numberFormat: true }}
            </td>
            <td class="mynovi-data-table_buttons new-claim-data_buttons">
              <button
                (click)="startNewClaim(shipmentLine)"
                class="button button--secondary theme-btn-primary-outline"
                i18n="@@new.claims.overview.start.button"
                >
              Start
            </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<ng-template modal-wrapper></ng-template>
